(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-allergen-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(root) {
    var sid         = root.dataset.sectionId;
    var summaryList = document.getElementById('kw-ag-summary-list-' + sid);
    var clearBtn    = document.getElementById('kw-ag-clear-' + sid);
    var badges      = root.querySelectorAll('.kw-ag__badge');

    function updateSummary() {
      var active = [];
      badges.forEach(function(btn) {
        if (btn.getAttribute('aria-pressed') === 'true') {
          active.push(btn.dataset.label);
        }
      });
      summaryList.textContent = active.length ? active.join(', ') : 'None';
    }

    badges.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var pressed = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
        updateSummary();
        root.dispatchEvent(new CustomEvent('kw:allergen-change', {
          bubbles: true,
          detail: { allergen: btn.dataset.allergen, active: !pressed }
        }));
      });
    });

    clearBtn.addEventListener('click', function() {
      badges.forEach(function(btn) { btn.setAttribute('aria-pressed', 'false'); });
      updateSummary();
      root.dispatchEvent(new CustomEvent('kw:allergen-change', {
        bubbles: true,
        detail: { allergen: null, active: false, cleared: true }
      }));
    });
  }

  document.querySelectorAll('.kw-ag[data-section-id]').forEach(initSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-e-ink-menu"] && !Shopify.designMode) return;
  try {
    
(function () {
  var FLICKER_MS = 200;
  var CYCLE_MS   = 20000;

  var ALLERGEN_ICONS = {
    dairy:       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M8 2h8l2 6-1 11a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L6 8Z"/><path d="M6 8h12"/></svg>',
    eggs:        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22c6 0 9-4.5 9-9 0-6-4-13-9-13S3 7 3 13c0 4.5 3 9 9 9Z"/></svg>',
    wheat:       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5.5a4.5 4.5 0 0 1 7 3.5c0 2.5-2 4.5-4.5 4.5"/><path d="M11 5.5S7.5 8 7 11.5a4.5 4.5 0 0 0 8 3"/><path d="M12 12v10"/><path d="M9 15l3 3 3-3"/></svg>',
    gluten:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5.5a4.5 4.5 0 0 1 7 3.5c0 2.5-2 4.5-4.5 4.5"/><path d="M11 5.5S7.5 8 7 11.5a4.5 4.5 0 0 0 8 3"/><path d="M12 12v10"/><path d="M9 15l3 3 3-3"/></svg>',
    fish:        '<span style="font-size:9px;font-weight:900;line-height:1">Fi</span>',
    crustaceans: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 11a2 2 0 1 1-4 0 4 4 0 0 1 4-4"/><path d="M10 11a2 2 0 0 0 4 0 4 4 0 0 0-4-4"/><path d="M12 18v4"/><path d="M8 22h8"/><path d="M2 15l4-3"/><path d="M22 15l-4-3"/><path d="M6 12l-4 1"/><path d="M18 12l4 1"/></svg>',
    mollusks:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 11a2 2 0 1 1-4 0 4 4 0 0 1 4-4"/><path d="M10 11a2 2 0 0 0 4 0 4 4 0 0 0-4-4"/><path d="M12 18v4"/><path d="M8 22h8"/><path d="M2 15l4-3"/><path d="M22 15l-4-3"/></svg>',
    soy:         '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.5 2.3C10.5 8 6 10 4 12c-2 2-3 5-1 8s5 4 8 4 7-2 8-5c1-4-1-7-5-8"/><path d="M10.5 2.3C9 7 11 10 13 12c2 2 3 5 1 8"/></svg>',
    celery:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 22 L12 2 L22 22"/><path d="M8 12 Q12 8 16 12"/></svg>',
    'tree-nuts': '<span style="font-size:9px;font-weight:900;line-height:1">Nt</span>',
    peanuts:     '<span style="font-size:9px;font-weight:900;line-height:1">Pn</span>',
    sesame:      '<span style="font-size:9px;font-weight:900;line-height:1">Se</span>',
    mustard:     '<span style="font-size:9px;font-weight:900;line-height:1">Mu</span>',
    sulfites:    '<span style="font-size:9px;font-weight:900;line-height:1">S₂</span>',
    corn:        '<span style="font-size:9px;font-weight:900;line-height:1">Co</span>',
  };

  var CHICKEN_SVG = '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">' +
    '<ellipse cx="32" cy="48" rx="26" ry="8" stroke-width="1.5"/>' +
    '<ellipse cx="32" cy="48" rx="18" ry="5" stroke-width="0.75" opacity="0.4"/>' +
    '<ellipse cx="32" cy="36" rx="14" ry="10" stroke-width="1.5"/>' +
    '<path d="M20 40c-4 3-6 8-5 12" stroke-width="1.5"/>' +
    '<path d="M17 52c-1 1-1 2 0 2" stroke-width="1"/>' +
    '<path d="M44 40c4 3 6 8 5 12" stroke-width="1.5"/>' +
    '<path d="M47 52c1 1 1 2 0 2" stroke-width="1"/>' +
    '<path d="M22 32c2-1 4-1 5 0" stroke-width="1" opacity="0.6"/>' +
    '<path d="M37 32c2-1 4-1 5 0" stroke-width="1" opacity="0.6"/>' +
    '<path d="M28 34c2 0.5 4 0.5 6 0" stroke-width="0.75" opacity="0.5"/>' +
    '<path d="M30 38c1 0.5 3 0.5 4 0" stroke-width="0.75" opacity="0.5"/>' +
    '<path d="M26 20c0-3 1.5-5 0.5-8" stroke-width="0.75" opacity="0.4"/>' +
    '<path d="M32 18c0-3 1.5-5 0.5-8" stroke-width="0.75" opacity="0.4"/>' +
    '<path d="M38 20c0-3 1.5-5 0.5-8" stroke-width="0.75" opacity="0.4"/>' +
    '</svg>';

  var STEAK_SVG = '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">' +
    '<ellipse cx="32" cy="48" rx="26" ry="8" stroke-width="1.5"/>' +
    '<ellipse cx="32" cy="48" rx="18" ry="5" stroke-width="0.75" opacity="0.4"/>' +
    '<path d="M18 36c2-6 8-10 14-10s12 4 14 10c1 3 0 6-2 8s-6 4-12 4-10-2-12-4-3-5-2-8z" stroke-width="1.5"/>' +
    '<path d="M18 36c1-2 2-3 4-3" stroke-width="1" opacity="0.6"/>' +
    '<path d="M46 36c-1-2-2-3-4-3" stroke-width="1" opacity="0.6"/>' +
    '<path d="M24 32c4 2 8 2 12 0" stroke-width="1" opacity="0.5"/>' +
    '<path d="M22 36c5 2 10 2 16 0" stroke-width="1" opacity="0.5"/>' +
    '<path d="M24 40c4 1 8 1 12 0" stroke-width="1" opacity="0.5"/>' +
    '<ellipse cx="32" cy="36" rx="6" ry="4" stroke-width="0.75" opacity="0.3"/>' +
    '<path d="M26 18c0-3 1.5-5 0.5-8" stroke-width="0.75" opacity="0.4"/>' +
    '<path d="M32 16c0-3 1.5-5 0.5-8" stroke-width="0.75" opacity="0.4"/>' +
    '<path d="M38 18c0-3 1.5-5 0.5-8" stroke-width="0.75" opacity="0.4"/>' +
    '</svg>';

  function isPoultry(name) {
    return /chicken|poultry|hen|fowl|wing|drumstick|turkey|duck/i.test(name);
  }

  function getNameFontSize(name) {
    var len = name.length;
    if (len > 22) return '1rem';
    if (len > 16) return '1.25rem';
    if (len > 12) return '1.5rem';
    return '1.8rem';
  }

  function initSection(root) {
    var sid       = root.dataset.sectionId;
    var menuEl    = document.getElementById('kw-em-menu-' + sid);
    var searchEl  = document.getElementById('kw-em-search-' + sid);
    var chipsEl   = document.getElementById('kw-em-chips-' + sid);
    var listEl    = document.getElementById('kw-em-list-' + sid);
    var screenEl  = document.getElementById('kw-em-screen-' + sid);
    var sketchEl  = document.getElementById('kw-em-sketch-' + sid);
    var nameEl    = document.getElementById('kw-em-name-' + sid);
    var descEl    = document.getElementById('kw-em-desc-' + sid);
    var allerEl   = document.getElementById('kw-em-allergens-' + sid);
    var dotEls    = [document.getElementById('kw-em-dot-' + sid), document.getElementById('kw-em-dot2-' + sid)];
    var statusEls = [document.getElementById('kw-em-status-' + sid), document.getElementById('kw-em-status2-' + sid)];
    var progWrap  = document.getElementById('kw-em-prog-wrap-' + sid);
    var progBar   = document.getElementById('kw-em-prog-bar-' + sid);

    if (!menuEl) return;

    var MENU    = JSON.parse(menuEl.textContent);
    var selCat  = 'All';
    var selItem = null;
    var cycleTimer = null;
    var cycleStart = null;
    var rafId = null;

    function setStatus(live) {
      dotEls.forEach(function(d) { d.classList.toggle('kw-em__dot--live', live); });
      statusEls.forEach(function(s) { s.textContent = live ? 'Live' : 'Idle'; });
    }

    function renderAllergens(allergens) {
      var slots = allerEl.querySelectorAll('.kw-em__allergen-slot');
      slots.forEach(function(slot, i) {
        var key = allergens[i];
        slot.className = 'kw-em__allergen-slot';
        if (key) {
          slot.classList.add('kw-em__allergen-slot--active');
          slot.setAttribute('title', key);
          slot.innerHTML = ALLERGEN_ICONS[key] || '<span style="font-size:9px;font-weight:900">' + key.charAt(0).toUpperCase() + '</span>';
        } else {
          slot.classList.add('kw-em__allergen-slot--empty');
          slot.removeAttribute('title');
          slot.innerHTML = '';
        }
      });
    }

    function flickerIn(callback) {
      screenEl.style.transition = 'none';
      screenEl.style.opacity = '0';
      setTimeout(function() {
        if (callback) callback();
        screenEl.style.transition = 'opacity 0.18s ease-in';
        screenEl.style.opacity = '1';
      }, FLICKER_MS);
    }

    function applyItem(item) {
      var name = item.name.toUpperCase();
      nameEl.textContent = name;
      nameEl.style.fontSize = getNameFontSize(name);
      descEl.textContent = item.description;
      sketchEl.innerHTML = isPoultry(item.name) ? CHICKEN_SVG : STEAK_SVG;
      renderAllergens(item.allergens.slice(0, 5));
    }

    function startCycle(item) {
      clearCycle();
      progWrap.style.display = '';
      progBar.style.width = '0%';
      cycleStart = Date.now();

      function tick() {
        var elapsed = Date.now() - cycleStart;
        var pct = Math.min(100, (elapsed / CYCLE_MS) * 100);
        progBar.style.width = pct + '%';
        if (elapsed < CYCLE_MS) {
          rafId = requestAnimationFrame(tick);
        } else {
          progWrap.style.display = 'none';
          progBar.style.width = '0%';
          flickerIn(function() { applyItem(item); });
          setStatus(true);
          cycleStart = null;
        }
      }
      rafId = requestAnimationFrame(tick);
    }

    function clearCycle() {
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      if (cycleTimer) { clearTimeout(cycleTimer); cycleTimer = null; }
      progWrap.style.display = 'none';
      progBar.style.width = '0%';
      cycleStart = null;
    }

    function selectItem(item, li) {
      selItem = item;
      listEl.querySelectorAll('.kw-em__item').forEach(function(el) {
        el.classList.remove('kw-em__item--active');
      });
      if (li) li.classList.add('kw-em__item--active');
      setStatus(false);
      statusEls.forEach(function(s) { s.textContent = 'Updating…'; });
      startCycle(item);
    }

    function filterItems() {
      var q = searchEl.value.trim().toLowerCase();
      return MENU.filter(function(item) {
        var catOk = selCat === 'All' || item.category === selCat;
        var qOk   = !q || item.name.toLowerCase().includes(q) ||
                    item.category.toLowerCase().includes(q) ||
                    item.subCategory.toLowerCase().includes(q);
        return catOk && qOk;
      });
    }

    function renderList() {
      var items = filterItems();
      listEl.innerHTML = '';
      if (!items.length) {
        var li = document.createElement('li');
        li.className = 'kw-em__empty';
        li.textContent = 'No items found';
        listEl.appendChild(li);
        return;
      }
      items.forEach(function(item) {
        var li = document.createElement('li');
        li.className = 'kw-em__item';
        if (selItem && selItem.id === item.id) li.classList.add('kw-em__item--active');
        li.setAttribute('role', 'option');
        li.innerHTML =
          '<div><div class="kw-em__item-name">' + item.name + '</div>' +
          '<div class="kw-em__item-meta">' + item.category + ' · ' + item.subCategory + '</div></div>' +
          '<span class="kw-em__item-temp">' + item.targetTemp + '</span>';
        li.addEventListener('click', function() { selectItem(item, li); });
        listEl.appendChild(li);
      });
    }

    searchEl.addEventListener('input', renderList);

    chipsEl.querySelectorAll('.kw-em__chip').forEach(function(btn) {
      btn.addEventListener('click', function() {
        chipsEl.querySelectorAll('.kw-em__chip').forEach(function(b) { b.classList.remove('kw-em__chip--active'); });
        btn.classList.add('kw-em__chip--active');
        selCat = btn.dataset.cat;
        renderList();
      });
    });

    renderList();
  }

  document.querySelectorAll('.kw-em[data-section-id]').forEach(initSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-temperature-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  var FLICKER_MS = 200;
  var CYCLE_MS   = 20000;
  var MIN_TEMP   = 140;
  var MAX_TEMP   = 180;
  var STEP       = 5;

  function clamp(v) { return Math.min(MAX_TEMP, Math.max(MIN_TEMP, v)); }

  function fdaLabel(t) {
    if (t >= 165) return 'Poultry & Stuffed';
    if (t >= 160) return 'Ground Meat & Eggs';
    if (t >= 145) return 'Seafood & Whole Cuts';
    return 'Holding Minimum';
  }

  function fillPct(t) { return ((t - MIN_TEMP) / (MAX_TEMP - MIN_TEMP)) * 100; }

  function initSection(root) {
    var sid       = root.dataset.sectionId;
    var rangeEl   = document.getElementById('kw-ts-range-' + sid);
    var decBtn    = document.getElementById('kw-ts-dec-' + sid);
    var incBtn    = document.getElementById('kw-ts-inc-' + sid);
    var liveEl    = document.getElementById('kw-ts-live-' + sid);
    var updateBtn = document.getElementById('kw-ts-update-' + sid);
    var screenEl  = document.getElementById('kw-ts-screen-' + sid);
    var displayVal= document.getElementById('kw-ts-display-val-' + sid);
    var fdaBadge  = document.getElementById('kw-ts-fda-badge-' + sid);
    var dotEls    = [document.getElementById('kw-ts-dot-' + sid), document.getElementById('kw-ts-dot2-' + sid)];
    var statusEls = [document.getElementById('kw-ts-status-' + sid), document.getElementById('kw-ts-status2-' + sid)];
    var progWrap  = document.getElementById('kw-ts-prog-wrap-' + sid);
    var progBar   = document.getElementById('kw-ts-prog-bar-' + sid);

    if (!rangeEl) return;

    var liveTemp     = parseInt(rangeEl.value, 10);
    var displayedTemp = liveTemp;
    var rafId = null;
    var cycling = false;

    function setStatus(live) {
      dotEls.forEach(function(d) { d.classList.toggle('kw-ts__dot--live', live); });
      statusEls.forEach(function(s) { s.textContent = live ? 'Live' : (cycling ? 'Updating…' : 'Idle'); });
    }

    function updateLive(t) {
      liveTemp = t;
      liveEl.textContent = t;
      rangeEl.value = t;
      rangeEl.setAttribute('aria-valuenow', t);
      rangeEl.style.setProperty('--kw-fill', fillPct(t) + '%');
    }

    function applyToDisplay(t) {
      displayedTemp = t;
      displayVal.textContent = t;
      fdaBadge.textContent = fdaLabel(t);
    }

    function flickerIn(callback) {
      screenEl.style.transition = 'none';
      screenEl.style.opacity = '0';
      setTimeout(function() {
        if (callback) callback();
        screenEl.style.transition = 'opacity 0.18s ease-in';
        screenEl.style.opacity = '1';
      }, FLICKER_MS);
    }

    function clearCycle() {
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      cycling = false;
      progWrap.style.display = 'none';
      progBar.style.width = '0%';
    }

    function startCycle(targetTemp) {
      clearCycle();
      cycling = true;
      updateBtn.disabled = true;
      progWrap.style.display = '';
      progBar.style.width = '0%';
      setStatus(false);
      var start = Date.now();

      function tick() {
        var elapsed = Date.now() - start;
        var pct = Math.min(100, (elapsed / CYCLE_MS) * 100);
        progBar.style.width = pct + '%';
        if (elapsed < CYCLE_MS) {
          rafId = requestAnimationFrame(tick);
        } else {
          cycling = false;
          progWrap.style.display = 'none';
          progBar.style.width = '0%';
          updateBtn.disabled = false;
          flickerIn(function() { applyToDisplay(targetTemp); });
          setStatus(true);
        }
      }
      rafId = requestAnimationFrame(tick);
    }

    rangeEl.addEventListener('input', function() {
      updateLive(clamp(parseInt(this.value, 10)));
    });

    decBtn.addEventListener('click', function() {
      updateLive(clamp(liveTemp - STEP));
    });

    incBtn.addEventListener('click', function() {
      updateLive(clamp(liveTemp + STEP));
    });

    updateBtn.addEventListener('click', function() {
      if (!cycling) startCycle(liveTemp);
    });

    /* Init */
    applyToDisplay(liveTemp);
    setStatus(true);
  }

  document.querySelectorAll('.kw-ts[data-section-id]').forEach(initSection);
})();

  } catch(e) { console.error(e); }
})();
})();
